import { __assign } from "tslib";
import { getElementPositionRectangle, setElementOffset, visiblePercentage } from '@wk/dom';
export var PlacementPosition;
(function (PlacementPosition) {
    PlacementPosition["TOP"] = "top";
    PlacementPosition["BOTTOM"] = "bottom";
    PlacementPosition["TOP_LEFT"] = "top-left";
    PlacementPosition["TOP_RIGHT"] = "top-right";
    PlacementPosition["BOTTOM_LEFT"] = "bottom-left";
    PlacementPosition["BOTTOM_RIGHT"] = "bottom-right";
    PlacementPosition["LEFT"] = "left";
    PlacementPosition["RIGHT"] = "right";
})(PlacementPosition || (PlacementPosition = {}));
export var defaultSmartPlacementOptions = {
    positions: [
        PlacementPosition.BOTTOM_RIGHT,
        PlacementPosition.BOTTOM_LEFT,
        PlacementPosition.BOTTOM,
        PlacementPosition.TOP_RIGHT,
        PlacementPosition.TOP_LEFT,
        PlacementPosition.TOP,
        PlacementPosition.LEFT,
        PlacementPosition.RIGHT
    ],
    topOffset: 0,
    leftOffset: 0
};
export function smartPlacement(handle, element, options) {
    if (options === void 0) { options = defaultSmartPlacementOptions; }
    var _options = __assign(__assign({}, defaultSmartPlacementOptions), options);
    var position = getVisiblePosition(handle, element, _options);
    var coordinates = getPlacementCoordinates(handle, element, position, options.topOffset, options.leftOffset);
    setElementOffset(element, coordinates);
    return position;
}
function setElementDimensions(element, width, height) {
    element.style.width = width + "px";
    element.style.height = height + "px";
}
function unsetElementDimensions(element) {
    ['top', 'left', 'width', 'height'].forEach(function (item) { return (element.style[item] = ''); });
}
function getVisiblePosition(handle, element, options) {
    var calculateVisibilityForPositions = function (position) {
        var originalCoordinates = element.getBoundingClientRect();
        unsetElementDimensions(element);
        var originalWidth = element.offsetWidth;
        var originalHeight = element.offsetHeight;
        var coordinatesToTry = getPlacementCoordinates(handle, element, position, options.topOffset, options.leftOffset);
        setElementOffset(element, coordinatesToTry);
        setElementDimensions(element, originalWidth, originalHeight);
        var percent = visiblePercentage(element);
        var isOverflowing = isOverflowingParent(handle, element);
        setElementOffset(element, originalCoordinates);
        return { position: position, percent: percent, isOverflowing: isOverflowing };
    };
    var isOverflowingParent = function (handle, element) {
        var parentEl = element.parentElement;
        var elementRect = element.getBoundingClientRect();
        while (parentEl && getComputedStyle(parentEl).position === 'static') {
            parentEl = parentEl.parentElement;
        }
        while (parentEl) {
            var _a = getComputedStyle(parentEl), overflow = _a.overflow, overflowX = _a.overflowX, overflowY = _a.overflowY;
            var hasOverflow = /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
            if (hasOverflow) {
                var parentRect = parentEl.getBoundingClientRect();
                return (elementRect.bottom > parentRect.bottom ||
                    elementRect.top < parentRect.top ||
                    elementRect.right > parentRect.right ||
                    elementRect.left < parentRect.left);
            }
            parentEl = parentEl.parentElement;
        }
        return false;
    };
    var calculatedVisibility = options.positions.map(calculateVisibilityForPositions);
    var fullyVisibleInViewport = function (ratio) {
        return ratio.percent === 1 && !ratio.isOverflowing;
    };
    var fullyVisiblePositions = calculatedVisibility.filter(fullyVisibleInViewport);
    var maxVisibility = calculatedVisibility.reduce(function (max, ratio) { return (ratio.percent > max ? ratio.percent : max); }, calculatedVisibility[0].percent);
    var mostVisiblePosition = calculatedVisibility.filter(function (ratio) { return ratio.percent === maxVisibility; });
    if (fullyVisiblePositions.length) {
        return fullyVisiblePositions[0].position;
    }
    else {
        if (mostVisiblePosition.length) {
            return mostVisiblePosition[0].position;
        }
        else {
            return options.positions[0];
        }
    }
}
function getPlacementCoordinates(handle, element, position, topOffset, leftOffset) {
    var elementWidth = element.offsetWidth, elementHeight = element.offsetHeight;
    var _a = getElementPositionRectangle(handle), targetTop = _a.top, targetLeft = _a.left, targetWidth = _a.width, targetHeight = _a.height;
    switch (position) {
        case PlacementPosition.TOP:
            return {
                top: targetTop - elementHeight - topOffset,
                left: targetLeft + targetWidth / 2 - elementWidth / 2
            };
        case PlacementPosition.TOP_LEFT:
            return {
                top: targetTop - elementHeight - topOffset,
                left: targetLeft + targetWidth - elementWidth + leftOffset
            };
        case PlacementPosition.TOP_RIGHT:
            return {
                top: targetTop - elementHeight - topOffset,
                left: targetLeft + leftOffset
            };
        case PlacementPosition.BOTTOM:
            return {
                top: targetTop + targetHeight + topOffset,
                left: targetLeft + targetWidth / 2 - elementWidth / 2
            };
        case PlacementPosition.BOTTOM_LEFT:
            return {
                top: targetTop + targetHeight + topOffset,
                left: targetLeft + targetWidth - elementWidth + leftOffset
            };
        case PlacementPosition.BOTTOM_RIGHT:
            return {
                top: targetTop + targetHeight + topOffset,
                left: targetLeft + leftOffset
            };
        case PlacementPosition.RIGHT:
            return {
                top: targetTop + targetHeight / 2 - elementHeight / 2,
                left: targetLeft + targetWidth + leftOffset
            };
        case PlacementPosition.LEFT:
            return {
                top: targetTop + targetHeight / 2 - elementHeight / 2,
                left: targetLeft - elementWidth - leftOffset
            };
        default:
            throw new Error('Wrong placement position');
    }
    return { top: targetTop, left: targetLeft };
}
